var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"dash-heading"},[_vm._v("Ticket Summary")]),_vm._v(" "),_c('good-table',{attrs:{"cols":_vm.cols,"rows":_vm.list,"row-style":_vm.cellClass}}),_vm._v(" "),_c('br')],1)}
var staticRenderFns = []

export { render, staticRenderFns }